module.exports = __webpack_public_path__ + "static/media/github2_white.40bd01fc.png";